export enum DashType {
  DASH = 'd',
  GAP = 'g',
  OFFSET = 'o',
}
